import { useState, useEffect, useCallback } from "react";
import { api } from "../services/api";

export function useLimits() {
  const [data, setData] = useState({ plan: null, limits: {}, usage: {} });
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const res = await api.subscriptions.getLimits();
      setData(res);
    } catch (e) {
      console.error("useLimits fetch error", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refetch(); }, [refetch]);

  const isAtLimit = useCallback((resource) => {
    // Recursos con prefijo max_ (cuentas, metas...) y contadores de IA, cuya
    // clave en PLAN_LIMITS ya es el nombre completo (duky_messages_month).
    const limit = data.limits[`max_${resource}`] ?? data.limits[resource];
    const usage = data.usage[resource];
    if (typeof limit !== "number" || typeof usage !== "number") return false;
    return usage >= limit;
  }, [data]);

  /**
   * ¿El plan del usuario incluye esta feature?
   * Para flags booleanos de PLAN_LIMITS: comparativa_meses, proyeccion,
   * exportar_datos. Mientras los límites cargan devuelve `true` para no
   * parpadear un bloqueo que quizá no aplique.
   */
  const hasFeature = useCallback((feature) => {
    if (loading) return true;
    const v = data.limits[feature];
    return typeof v === "boolean" ? v : true;
  }, [data, loading]);

  return { ...data, loading, refetch, isAtLimit, hasFeature };
}
